export const KEY = 'auth';
export const TELEMEDICINE_DATA_KEY = 'medicalReceptionData';
export const FROM = 'from';
